<div class="customer-information">
  <div class="title">Contact Information</div>
  <form class="content" (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-row" *ngFor="let formField of formFields">
      <form-field [formField]="formField" [form]="form"></form-field>
    </div>
  </form>
</div>
<p-table></p-table>
